import * as React from 'react';
import { useWindowSize } from '../hoc/useWindowSizeHOC';
import { isiOS } from '../mediaQueries';
import { Header } from './Header';


export const Layout: React.FC<{ headerPageScroll: string }> = ({ headerPageScroll, children }) => {
    const [width, height] = useWindowSize();

    // $fromSmallH: 30px;
    // $toSmallH: 70px;

    const getSticky = () => {
        const h = (window.innerWidth < 768 ? 30 : 70);
        const padd = (window.innerWidth <= 576 ? 20 : 30) * 2
        const iosAdapt = isiOS() ? -20 : 0
        return h + padd + iosAdapt;
    }

    const [stickyHeight, setStickyHeight] = React.useState(getSticky());
    // const [windowW, setWindowW] = React.useState(window.innerWidth);

    const updateWindowSize = e => {
        // console.info('updateWidthAndHeight', window.innerWidth)
        // setWindowW(window.innerWidth)
        setStickyHeight(getSticky());
    }

    const storeCampaignId = () => {
        // get campaign from url into Session Storage
        var c = getQueryVariable("campaign_id");
        // console.warn(c);
        sessionStorage.setItem('campaignId', c);

        function getQueryVariable(variable) {
            // console.log('getQueryVariable')
            var query = window.location.search.substring(1);
            // console.log(query);
            var vars = query.split("&");
            // console.log(vars);
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                // console.log(pair)
                if (pair[0] == variable) { return pair[1]; }
            }
            return (null);
        }
    }

    React.useEffect(() => {
        window.addEventListener("resize", updateWindowSize);
        storeCampaignId();
        return () => window.removeEventListener("resize", updateWindowSize);
    }, [])

    const childrenWithProps = React.Children.map(children, child => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { height, stickyHeight });
        }
        return child;
    });


    return <div className={'santander-react-layout'}>
        <Header height={height} headerPageScroll={headerPageScroll} />
        {childrenWithProps}
    </div>
}